import React, { useEffect, useRef } from 'react';

type Props = {
  slug: string;
  recipeId: string;
  currentLocale: string;
  servingSize?: number;
  config?: {
    [locale: string]: {
      id: string;
      prefix?: string;
    };
  };
};

const HappyCartButton = ({ config, slug, currentLocale, recipeId, servingSize }: Props) => {
  const componentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const addAriaLabels = () => {
      if (componentRef.current) {
        const buttons = componentRef.current.querySelectorAll('button');

        buttons[0]?.setAttribute('aria-label', 'Go to shopping list');
        buttons[1]?.setAttribute('aria-label', 'Add to shopping cart');
      }
    };

    // You might need a small delay to ensure the third-party script has rendered the buttons
    const timeoutId = setTimeout(addAriaLabels, 1000);

    return () => clearTimeout(timeoutId);
  }, []);

  if (!config) {
    return null;
  }

  const channelId = config[currentLocale]?.id;

  if (!channelId) {
    return null;
  }

  const prefix = config[currentLocale]?.prefix || 'dr-oetker';

  // TODO: Remove this once the recipeId is working for AT. At the moment only the slug is working for AT.
  const buttonRecipeId = currentLocale === 'de_AT' ? slug : recipeId;

  return (
    <div className="print:hidden" ref={componentRef}>
      {/* @ts-ignore */}
      <happy-cart channel-id={channelId} />
      {/* @ts-ignore */}
      <happy-cart-button recipe-id={`${prefix}-${buttonRecipeId}`} serving-size={servingSize} />
    </div>
  );
};

export default HappyCartButton;
